var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-auto" },
      [
        _c("input-group", { attrs: { icon: "far fa-hourglass" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.time,
                expression: "time"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "number", disabled: _vm.disabled || !_vm.unit },
            domProps: { value: _vm.time },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.time = $event.target.value
              }
            }
          })
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-auto" },
      [
        _c(
          "input-group",
          { attrs: { icon: "far fa-clock" } },
          [
            _vm.options.length != 0
              ? _c(
                  "v-select",
                  {
                    staticClass: "form-control",
                    attrs: {
                      options: _vm.options,
                      clearable: false,
                      "close-on-select": "",
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.unit,
                      callback: function($$v) {
                        _vm.unit = $$v
                      },
                      expression: "unit"
                    }
                  },
                  [
                    _c("div", {
                      attrs: { slot: "no-options" },
                      slot: "no-options"
                    })
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.showBeforeAfter
      ? _c("div", { staticClass: "col-auto" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.beforeAfter,
                expression: "beforeAfter"
              }
            ],
            attrs: {
              type: "radio",
              id: _vm.afterElementId,
              value: "after",
              disabled: _vm.disabled
            },
            domProps: { checked: _vm._q(_vm.beforeAfter, "after") },
            on: {
              change: function($event) {
                _vm.beforeAfter = "after"
              }
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: _vm.afterElementId } }, [
            _vm._v(
              _vm._s(_vm.resource("JourneyBuilder_FilterSettings_Offset_After"))
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.beforeAfter,
                expression: "beforeAfter"
              }
            ],
            attrs: {
              type: "radio",
              id: _vm.beforeElementId,
              value: "before",
              disabled: _vm.disabled
            },
            domProps: { checked: _vm._q(_vm.beforeAfter, "before") },
            on: {
              change: function($event) {
                _vm.beforeAfter = "before"
              }
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: _vm.beforeElementId } }, [
            _vm._v(
              _vm._s(
                _vm.resource("JourneyBuilder_FilterSettings_Offset_Before")
              )
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }